export default Marionette.CollectionView.extend({
    className: 'showcase__content'
});
